import { create } from 'zustand';

interface CommandStore {
  isOpen: boolean;
  searchQuery: string;
  setOpen: (open: boolean) => void;
  toggle: () => void;
  setSearchQuery: (query: string) => void;
  reset: () => void;
}

export const useCommandStore = create<CommandStore>((set) => ({
  isOpen: false,
  searchQuery: '',
  setOpen: (open) => set({ isOpen: open }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  setSearchQuery: (query) => set({ searchQuery: query }),
  reset: () => set({ isOpen: false, searchQuery: '' }),
}));
